export default "__VITE_ASSET__DfGTS79y__"